/**
 * @desc TheNewAnnualSalesPlan
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/sale/indicator/add',
    data,
  });
}

export function mock(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/sale/indicator/add',
    data,
  });
}
